import cx from "classnames";
import type { Element } from "React";
import { Component } from "react";
import { FormattedMessage } from "react-intl";
import { IconBack } from "../Icon/Icon";
import "./BackButton.scss";
type Props = {
  history: any;
  className?: string;
  mobile?: boolean;
};

class Button extends Component<Props> {
  render(): Element<"button"> | Element<"div"> {
    let { className, history, mobile } = this.props;

    if (mobile) {
      return (
        <button
          className={cx("back-button__mobile", className)}
          onClick={history.back || history.goBack}
          data-qa="back-button"
        >
          <IconBack />
        </button>
      );
    } else {
      return (
        <div
          onClick={history.back || history.goBack}
          className={cx("title__back", className)}
          data-qa="back-button"
        >
          <IconBack />
          <FormattedMessage tagName="span" id="events-dashboard-back" />
        </div>
      );
    }
  }
}

export default Button;
